import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SequenceMenu, useNotifications } from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'

const TOAST_ID = 'invoice.menuItem.markAsUnpaid'
export const MarkAsUnpaid = (props: {
  invoiceId: string
  invoiceNumber: string | undefined
  onSuccess?: () => void
}) => {
  const { displayNotification } = useNotifications()
  const { can } = usePermissions()

  const unpaidMutation = useMutation(
    dashboard20240730Client.putInvoicePaymentStatus,
    {
      onSuccess: () => {
        displayNotification(
          `Invoice ${props.invoiceNumber || ''} marked as unpaid`,
          {
            type: 'success',
            id: TOAST_ID
          }
        )
        props.onSuccess?.()
      },
      onError: () => {
        displayNotification(
          `Invoice ${props.invoiceNumber || ''} could not be updated`,
          {
            type: 'error',
            id: TOAST_ID
          }
        )
      }
    }
  )

  if (!can('org.invoice:update')) {
    return null
  }

  return (
    <SequenceMenu.Item
      data-testid="invoices.markAsUnpaid.menuItem"
      uuid="mark-as-unpaid"
      label="Mark as unpaid"
      onClick={() => {
        displayNotification(
          `Marking invoice ${props.invoiceNumber || ''} as unpaid...`,
          {
            type: 'info',
            id: TOAST_ID
          }
        )
        unpaidMutation.mutate({
          invoiceId: props.invoiceId,
          paymentStatus: 'UNPAID'
        })
      }}
    />
  )
}
